export const lt = (x, y) => Number(x) < Number(y)
